/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Rail_HoursInputs */

const en_start_page_rail_hours = /** @type {(inputs: Start_Page_Rail_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hours`)
};

const pl_start_page_rail_hours = /** @type {(inputs: Start_Page_Rail_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godziny`)
};

/**
* | output |
* | --- |
* | "Hours" |
*
* @param {Start_Page_Rail_HoursInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_rail_hours = /** @type {((inputs?: Start_Page_Rail_HoursInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Rail_HoursInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_rail_hours(inputs)
	return en_start_page_rail_hours(inputs)
});